import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export const CONNECTION_PROFILE_DELETED = 'CONNECTION_PROFILE_DELETED';
export const CONNECTION_PROFILE_CREATED = 'CONNECTION_PROFILE_CREATED';

export const CONNECTION_TESTED_SUCCESSFULLY = 'CONNECTION_TESTED_SUCCESSFULLY';

export function useConnectionProfilesService() {
  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const deleteConnectionProfile = async (id: number) => {
    await backendApi.delete(`/integrations/profiles/${id}`);

    eventsPublisher.publish(CONNECTION_PROFILE_DELETED, {
      id,
    });
  };

  const testConnectionProfile = async (id: number) => {
    await backendApi.post(`/integrations/profiles/${id}/test`);

    eventsPublisher.publish(CONNECTION_TESTED_SUCCESSFULLY, { id });
  };

  return {
    deleteConnectionProfile,
    testConnectionProfile,
  };
}
